export default {
    data() {
        return {
            breakpoints: breakpoints, // See main.js
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth,
        }
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    computed:{
        breakpointsPx(){
            let breakpoints = {}
            for(const breakpoint in this.breakpoints){
                breakpoints[breakpoint] = this.convertToPxNumber(this.breakpoints[breakpoint])
            }
            return breakpoints
        }
    },
    methods: {
        breakpoint(width, minmax = 'min'){
            return window.matchMedia(`(${minmax}-width: ${this.breakpoints[width]})`).matches;
        },
        onResize() {
            this.windowHeight = window.innerHeight
            this.windowWidth = window.innerWidth
        },
        convertToPxNumber(size){

            if(typeof size === 'string'){
                if(size.includes('px')){
                    return Number(size.replace('px', ''))
                }
                else if(size.includes('rem') || size.includes('em')){
                    let relativeNumber = Number(size.replace('rem', '').replace('em',''))
                    return relativeNumber * 16
                }
                else {
                    return size
                }
            }
            else {
                return size
            }
        }
    },
}